var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[(_vm.mainInfo.show)?_c('img',{staticClass:"center",attrs:{"src":'/api/common/path/' + this.mainInfo.filePath + '?name='+ encodeURI(encodeURIComponent(this.mainInfo.fileName))}}):_vm._e(),_c('div',{attrs:{"id":"wrap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }